import { render, staticRenderFns } from "./OrderDetailsModal.vue?vue&type=template&id=c06b6168&scoped=true"
import script from "./OrderDetailsModal.vue?vue&type=script&lang=js"
export * from "./OrderDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06b6168",
  null
  
)

export default component.exports